export const LOCAL_STORAGE = {
  USER: "rgc_dtp_portal.user",
  EXPIRED_TOKEN: "rgc_dtp_portal.expiredtoken",
  EXPORT_SURVEY_TOKEN: "rgc_dtp_portal.exportsurveyToken",
  EXPORT_FILE_SUCCESS_TIME: "rgc_dtp_portal.fileExportTime",
  UPLOAD_ANCESTRY_TOKEN: "rgc_dtp_portal.uploadAncestryToken",
  OTP_ID: "otpid",
};
